import React, { useRef, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Footer from "../components/footer";
import NavigationBar from "../components/navigationbar";
import aboutus from "../assets/aboutus.png";
import MasjidLogos from "../components/masjidLogos";
import ZakatChart from "../components/zakatchart";
import { FaCalculator } from "react-icons/fa";
import { FaHandHoldingHeart } from "react-icons/fa6";



export const HowItWorks = () => {
    const exampleCaseRef = useRef(null);

    useEffect(() => {
        if (window.location.hash === '#example-case') {
            exampleCaseRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);
    return (
        <div className="home-page">
            <NavigationBar />
            <div
                className="position-relative"
                style={{
                    overflow: "hidden",
                    background: "linear-gradient(to right, #b8cfbd 0%, white 100%)",
                }}
            >
                <Row className=" px-5 my-3">
                    <h4 className="text-center my-0 py-0"> Greater Austin Muslim Relief Committee </h4>

                    {/* Left Side: Text Content */}
                    <Col
                        className="d-flex flex-column justify-content-center text-start px-5"
                        md={5}
                    >
                        <Container className="px-5">
                            <h1 className="fw-bold">How It Works:</h1>
                            <h2 className="fw-semibold">From Generosity to Relief</h2>
                            <p className="fs-5 mt-4">
                                See how your Zakat flows through local Masajid
                                to support those in hardship.
                            </p>
                        </Container>
                    </Col>

                    {/* Right Side: Image + Label */}
                    <Col
                        className="d-flex flex-column align-items-center text-center position-relative"
                        md={6}
                    >
                        <img
                            src={aboutus}
                            alt="Zakat Flow"
                            className="img-fluid"
                            style={{ width: "100%", marginTop: "6rem" }}
                        />
                    </Col>
                </Row>
            </div>

            <Container className="mb-5">

                <div className="text-left my-3 mx-4">
                    <Row>
                        {/*intro text*/}
                        <p>
                            The Greater Austin Muslim Relief Committee (GAMRC) is a unified effort of all local Austin Masajid,
                            working together to fulfill the obligation of Zakah and provide aid to those in need. While GAMRC
                            is NOT an independent organization, it serves as a trusted channel for distributing Zakat
                            to individuals and families facing hardship, as well as Sadqah to non-Muslims in need.
                            Your Zakat can be paid through any of the participating Masajid linked below. GAMRC ensures
                            that these funds are properly allocated to support essential needs such as food, shelter, medical care, and education.
                        </p>
                        <div className="my-4" id="example-case" ref={exampleCaseRef}>
                            <h2 className="fw-bold">How Much It Takes to Support a Family in Austin</h2>
                            <p>
                                Austin is an amazing city, but it costs a lot to live here. Living expenses are high, and many families struggle to afford essentials like rent, electricity, and food. This burden is especially heavy for single moms and refugee families.
                            </p>

                            <Row>
                                {/* Left side: bullets */}
                                <Col md={6}>
                                    <ul style={{ fontSize: "16px", lineHeight: "1.5", paddingRight: "1rem" }}>
                                        <li style={{ marginBottom: "1rem" }}>
                                            Many refugees face <strong>skill barriers</strong>, <strong>low-paying jobs</strong>, large families, and <strong>limited government assistance</strong> (like food stamps) that don’t cover rent or utilities.
                                        </li>
                                        <li style={{ marginBottom: "1rem" }}>
                                            Support lasts from <strong>6 to 24 months</strong> depending on education, skills, and children’s ages until families can stand on their own.
                                        </li>
                                        <li style={{ marginBottom: "1rem" }}>
                                            We also help <strong>revert Muslims</strong> transition out of shelters, supporting their <strong>spiritual connection</strong> alongside basic needs.
                                        </li>
                                        <li style={{ marginBottom: "1rem" }}>
                                            We prepare single moms for about <strong>six months</strong> to gain skills for employment. Caring for young children makes working difficult, and <strong>child care is expensive</strong>, so we provide <strong>extended support</strong>.
                                        </li>
                                        <li style={{ marginBottom: "1rem" }}>
                                            Small donations between <strong>$200 and $300</strong> fall short of what families need to escape poverty and build lasting stability. <strong>Zakat</strong> is a right for everyone — refugees, reverts, elders — and should fully meet real needs.
                                        </li>
                                        <li>
                                            Life in Austin is different — costs are higher, <strong>halal food</strong> is more expensive, and families have diverse needs. Zakat respects this by providing <strong>food certificates</strong> so families can choose what they buy, ensuring dignity and cultural relevance.
                                        </li>
                                    </ul>
                                </Col>


                                {/* Right side: table */}
                                <Col md={6} className="d-flex flex-column align-items-center">
                                    <h4 style={{
                                        fontWeight: 700,
                                        marginBottom: ".5rem",
                                        width: "100%",
                                        maxWidth: "400px",
                                        textAlign: "center",
                                        color: "#3C256B",
                                    }}>
                                        Min. Living Cost: Single Mother with Children
                                    </h4>
                                    <p style={{ maxWidth: '400px', textAlign: 'center', fontSize: '1rem' }}>Sister S.J. from our community was kicked out by her husband along with her young children. Sadly, there are multiple cases like this within our community.</p>
                                    <table
                                        style={{
                                            width: "100%",
                                            maxWidth: "400px",
                                            borderCollapse: "collapse",
                                            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                                            boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
                                        }}
                                    >
                                        <thead>
                                            <tr style={{ backgroundColor: "#3C256B", color: "white", textTransform: "uppercase", fontSize: "0.85rem" }}>
                                                <th style={{ padding: "12px", borderBottom: "2px solid #C9DDAD", textAlign: "left" }}>Expense</th>
                                                <th style={{ padding: "12px", borderBottom: "2px solid #C9DDAD", textAlign: "right" }}>Monthly Cost ($)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[
                                                { label: "Rent", amount: 1500 },
                                                { label: "Electricity", amount: 200 },
                                                { label: "Water", amount: 100 },
                                                { label: "Clothing", amount: 100 },
                                                { label: "Grocery / Food", amount: 1000 },
                                                { label: "Education (annual $8,000)", amount: 667 },
                                            ].map(({ label, amount }, idx) => (
                                                <tr
                                                    key={label}
                                                    style={{ backgroundColor: idx % 2 === 0 ? "#fff" : "#F7F9F8", color: "#3C256B" }}
                                                >
                                                    <td style={{ padding: "10px", borderBottom: "1px solid #C9DDAD" }}>{label}</td>
                                                    <td style={{ padding: "10px", borderBottom: "1px solid #C9DDAD", textAlign: "right" }}>{amount.toLocaleString()}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr style={{ backgroundColor: "#C9DDAD", color: "#3F562F", fontWeight: "700", fontSize: "0.9rem" }}>
                                                <td style={{ padding: "12px", borderTop: "2px solid #3F562F" }}>Total Monthly</td>
                                                <td style={{ padding: "12px", borderTop: "2px solid #3F562F", textAlign: "right" }}>
                                                    {(1500 + 200 + 100 + 100 + 1000 + 667).toLocaleString()}
                                                </td>
                                            </tr>
                                            <tr style={{ backgroundColor: "#C9DDAD", color: "#3F562F", fontWeight: "700", fontSize: "0.9rem" }}>
                                                <td style={{ padding: "12px", borderTop: "1px solid #3F562F" }}>Total Annual</td>
                                                <td style={{ padding: "12px", borderTop: "1px solid #3F562F", textAlign: "right" }}>
                                                    {((1500 + 200 + 100 + 100 + 1000 + 667) * 12).toLocaleString()}
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </Col>


                            </Row>
                        </div>


                        <h4>How We Distribute Aid:</h4>
                        <p>
                            To ensure Zakat is given to those truly in need, GAMRC has a careful application and review process.
                            Individuals or families seeking assistance can apply by submitting a form along with required documents,
                            including valid ID for both husband and wife, a lease agreement, pay stubs, bank statements, etc.
                            Each local masjid has a dedicated GAMRC member. Once the documents are submitted, the ID will be
                            forwarded to the GAMRC representatives, who will then conduct an interview to gain a deeper
                            understanding of the applicant’s situation. After that, requests for checks will be sent to different mosques.
                            This process ensures that funds are distributed with integrity, compassion, and accountability.
                        </p>

                        <div className="d-flex gap-3 mt-3 flex-wrap">
                            <Button
                                href="https://irusa.org/zakat-calculator/"
                                className="nav-button zakat-button"
                                target="_blank"
                                style={{
                                    minWidth: "300px",
                                    whiteSpace: "nowrap",
                                    padding: "0.6rem 1.2rem"
                                }}
                            >
                                <FaCalculator className="mb-1 mx-2" />
                                Calculate Your Zakat
                            </Button>
                            <Button
                                href="/PayZakatHere"
                                className="nav-button zakat-button"
                                target="_blank"
                                style={{
                                    minWidth: "300px",
                                    whiteSpace: "nowrap",
                                    padding: "0.6rem 1.2rem"
                                }}
                            >
                                <FaHandHoldingHeart className="mb-1 mx-2" />
                                Pay Zakat Here
                            </Button>
                        </div>

                    </Row>
                </div>


                <hr className="my-4" style={{ height: '2px', backgroundColor: 'black' }} />


                <Col className="text-center my-4">
                    <p>
                        Donate <a href="/PayZakatHere">here</a> or give your Zakat through Austin-area masajid to
                        help strengthen your community.
                    </p>
                    <MasjidLogos />
                    <p style={{ fontSize: '16px', color: '#000' }}>JazakAllah Khair to our most generous communities at Nueces Mosque, ICBC and ICGA</p>
                </Col>
                <hr className="my-4" style={{ height: '2px', backgroundColor: 'black' }} />
                <Row>
                    <div style={{ flex: 1, marginRight: '20px' }}>
                        <h2 style={{ fontSize: '24px', marginBottom: '10px' }}>Where Does The Zakat Go?</h2>
                        <p style={{ fontSize: '16px', color: '#000' }}>
                            GAMRC helps support vulnerable families in austin by paying for rent,
                            electricity, food and some cases of urgent debts and medical expenses.
                            Provides support to domestic violence cases, single moms, widows, and
                            orphans.  Provides a food basket twice during the blessed month of Ramadan.
                            Operates a space in a low-income complex for refugee kids to attend
                            quran classes and educational programs.
                        </p>
                        <Button
                            href="/WhatWeDo"
                            style={{ backgroundColor: "#42226D", borderColor: "#42226D", width: "200px" }}
                            className="nav-button"
                            target="_blank">
                            What We Do
                        </Button>
                    </div>

                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center', maxHeight: '40vh', minHeight: '30vh', marginTop: '0px' }}>
                        <ZakatChart />
                    </div>
                </Row>
            </Container>
            <Footer />
        </div>
    );
};

export default HowItWorks;
